import { useState, useCallback } from "react";
var useToggle = function (defaultValue) {
    if (defaultValue === void 0) { defaultValue = false; }
    var _a = useState(defaultValue), isOpen = _a[0], setIsOpen = _a[1];
    var toggle = useCallback(function () { return setIsOpen(function (state) { return !state; }); }, []);
    return [isOpen, setIsOpen, toggle];
};
export default useToggle;
